import React from "react";

const SOW = () => {
  return (
    <section className="min-h-screen flex items-center justify-center p-6 pt-16 bg-gray-100">
      <article className="bg-transparent shadow-lg rounded-2xl p-8 w-full max-w-3xl">
        <header className="text-center mb-6">
          <h2 className="text-3xl font-bold text-blue-600">
            Statement of Work (SOW)
          </h2>
        </header>

        <section className="mb-6">
          <p className="text-gray-700">
            <b>Statement of Work (SOW) Services</b> by <b>Talennect</b> help
            businesses streamline projects with clear deliverables, timelines,
            and resource management. Our expertly crafted SOW solutions ensure
            your projects are completed on time, within budget, and aligned with
            your business objectives.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Why Choose SOW Services?
          </h3>
          <p className="text-gray-700">
            Managing projects without a clear framework can lead to
            inefficiencies, scope creep, and budget overruns. Our{" "}
            <b>Statement of Work (SOW) services</b> provide a structured
            approach, defining project scope, key milestones, deliverables, and
            performance metrics to ensure seamless execution.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Our SOW Process
          </h3>
          <p className="text-gray-700">
            At <b>Talennect</b>, we follow a strategic approach to SOW
            management, including{" "}
            <b>
              requirement analysis, scope definition, budgeting, risk
              assessment, and compliance management
            </b>
            . Our detailed documentation and expert oversight help businesses
            mitigate risks while maintaining project efficiency.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-xl font-semibold text-blue-600">
            Industries We Support
          </h3>
          <p className="text-gray-700">
            Our SOW services cater to industries such as{" "}
            <b>IT, engineering, healthcare, finance, and manufacturing</b>.
            Whether you need project-based staffing, managed services, or vendor
            compliance oversight, we provide customized solutions to drive
            project success.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-blue-600">
            Partner with Talennect for Effective Project Execution
          </h3>
          <p className="text-gray-700">
            Ensure project success with <b>Talennect’s SOW solutions</b>. From
            defining project scope to ensuring quality execution, our team helps
            you stay on track and maximize efficiency. Contact us today to learn
            how our <b>Statement of Work services</b> can streamline your
            projects.
          </p>
        </section>
      </article>
    </section>
  );
};

export default SOW;
